export default "__VITE_ASSET__f8f1a0f9__"